import { State, Action, StateContext, Actions, ofActionSuccessful } from '@ngxs/store';
import { StoreSourceInfos, GetIssuers, GetProducts, StoreResource, StoreInfoUser } from './app.actions';
import { Injectable } from '@angular/core';
import { Dispatcher } from './base/dispatcher';
import { LocalStorageService } from 'ngx-webstorage';
import { EventManager, UserService } from '../core';
import { UsersService } from '../modules/users/users.service';
import { AppsService } from '../shared/services/apps.service';
declare let $: any;
export interface AppStateModel {
    userProfile: any;
    sourceInfos: any;
    resources: any;
    issuers: any;
    products: any;
}

export function initAppState(): AppStateModel {
    return {
        issuers: [],
        products: []
    } as AppStateModel;
}

@State<AppStateModel>({
    name: 'App',
    defaults: initAppState()
})
@Injectable()
export class AppState {

    constructor(
        private actions$: Actions,
        private dispatcher: Dispatcher,
        private appsService: AppsService,
        private localStorage$: LocalStorageService,
        public eventManger: EventManager,
    ) { }

    @Action(StoreInfoUser)
    StoreInfoUser(ctx: StateContext<AppStateModel>, action: StoreInfoUser) {
        const userProfile = action.payload;
        ctx.patchState({
            userProfile
        });
        this.GetProducts(ctx, action);
    }
    @Action(StoreSourceInfos)
    StoreSourceInfos(ctx: StateContext<AppStateModel>, action: StoreSourceInfos) {
        const sourceInfos = action.payload;
        ctx.patchState({
            sourceInfos
        });
    }
    parseSourceInfos(list) {
        return list.map((item) => {
          const obj = Object.keys(item);
          return {
            id: obj[0],
            code: obj[0],
            name: item[obj[0]],
          };
        });
    }
    @Action(StoreResource)
    StoreResource(ctx: StateContext<AppStateModel>, action: StoreResource) {
        return this.appsService.getResources()
        .subscribe((res: any) => {
            const resources = res.body.data || {};
            (resources.phonePostalCodes || []).forEach((item, index) => {
                item.id = index;
                item.name = item.countryCode + ' (+' + item.callingCode + ')';
            });
            (resources.dataRelationalOperator || []).forEach((operator) => {
                switch (operator.name) {
                  case '<=':
                  operator.reverseOperator = '>=';
                  break;
                  case '<':
                  operator.reverseOperator = '>';
                  break;
                  case '>=':
                  operator.reverseOperator = '<=';
                  break;
                  case '>':
                  operator.reverseOperator = '<';
                  break;
                }
            });
            resources.premiumTerms = resources.premiumTerms || [];
            resources.assuredTerms = resources.assuredTerms || [];
            resources.paymentModes = this.parseSourceInfos(resources.paymentModes);
            ctx.patchState({
                resources
            });
        });
    }
    @Action(GetProducts)
    GetProducts(ctx: StateContext<AppStateModel>, action: GetProducts) {
        let body = {
            page: 1,
            size: 250,
        };
        return this.appsService.getListProduct(body)
        .subscribe((res: any) => {
            const products = res.data.rows || [];
            ctx.patchState({
                products
            });
        });
    }
}
